import {
    AIModelCategory,
    AIModelCategoryMap,
    AIModelFramework,
    AIModelFrameworkMap,
    AIModelTask,
    AIModelTaskMap,
    AppProjectType,
    AppProjectTypeMap,
    AppRegistration,
    AppRegistrationMap,
    Breadcrumb,
    DateFormat,
    parseTime,
    getAuthToken,
    useAppUri,
    withAuthHandoff,
} from '@common';
import { MPButton } from '@components';
import { Typography } from 'antd';
import _get from 'lodash/get';
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useCurrentApp } from './hooks';
import DeleteAppModal from './sections/edit-app/DeleteAppModal';
import Styles from './Styles.module.scss';
import Tags from './Tags';
import cs from 'classnames';
import Analytics from './sections/analytics';

export default function AppDetails() {
    const { app } = useCurrentApp();
    const appUri = useAppUri(app?.name);
    const [modalOpen, setModalOpen] = useState(false);

    return (
        <>
            <Breadcrumb breadcrumbNameChangeMap={{ ':name': app?.name as string }} />
            <div className={Styles.ButtonGroup}>
                <MPButton
                    danger
                    onClick={() => setModalOpen(true)}
                    className="w-30"
                >
                    Delete
                </MPButton>

                <Link to={`/a/${app?.name}/edit`}>
                    <MPButton className="w-30">Edit</MPButton>
                </Link>

                <Typography.Link
                    href={withAuthHandoff(appUri, getAuthToken())}
                    target="_blank"
                >
                    <MPButton
                        type="primary"
                        className={cs(Styles.AppButton, 'w-30')}
                    >
                        Go to App
                    </MPButton>
                </Typography.Link>
            </div>
            <div className={Styles.ModelCard}>
                <div className={Styles.ModelCardHeader}>
                    <h2 className={Styles.ModelTitle}> {app?.title}</h2>
                    <Tags />
                </div>
                <div className={Styles.ModelCardBody}>
                    <div className={Styles.ModelDetailsContainer}>
                        {columns.map(column => (
                            <div
                                key={column.name}
                                className={Styles.ModelDescription}
                            >
                                <strong className={Styles.LabelText}>{column.label} :</strong>{' '}
                                {column.render?.(_get(app, column.name) as never) ?? _get(app, column.name) ?? '-'}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <Analytics />

            <DeleteAppModal
                modalOpen={modalOpen}
                setModalOpen={setModalOpen}
            />
        </>
    );
}

const columns = [
    {
        name: 'name',
        label: 'App Name',
    },
    {
        name: 'description',
        label: 'Description',
    },
    {
        name: 'appType',
        label: 'App Type',
        render: (value: AppProjectType) => AppProjectTypeMap[value],
    },
    {
        name: 'aiModelProperties.category',
        label: 'AI Category',
        render: (value: AIModelCategory) => AIModelCategoryMap[value],
    },
    {
        name: 'aiModelProperties.task',
        label: 'AI Task',
        render: (value: AIModelTask) => AIModelTaskMap[value],
    },
    {
        name: 'aiModelProperties.framework',
        label: 'Web Framework',
        render: (value: AIModelFramework) => AIModelFrameworkMap[value],
    },
    {
        name: 'registrationType',
        label: 'Model Type',
        render: (value: AppRegistration) => AppRegistrationMap[value],
    },
    {
        name: 'ownerName',
        label: 'Added By',
    },
    {
        name: 'updatedAt',
        label: 'Last Updated',
        render: (value: string) => parseTime(value, DateFormat.Date),
    },
    {
        name: 'createdAt',
        label: 'Added',
        render: (value: string) => parseTime(value, DateFormat.Date),
    },
];
